import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { PresentationIcon16Solid } from "../../../../../icons2022/FileTypePresentationIcon/PresentationIcon16Solid";
import { PresentationIcon20Solid } from "../../../../../icons2022/FileTypePresentationIcon/PresentationIcon20Solid";
import { PresentationIcon24Solid } from "../../../../../icons2022/FileTypePresentationIcon/PresentationIcon24Solid";
export var PresentationIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(PresentationIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(PresentationIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(PresentationIcon24Solid, null);
  }
}, 'PresentationIcon');